import Promotion from './Promotion'

export default Promotion
// eslint-disable-next-line import/export
export * from './Promotion'
